<template>
  <div>
    <v-row class="d-flex justify-center mt-0">
      <v-col cols="12">
        <v-expansion-panels v-model="panel">
          <v-expansion-panel readonly>
            <!-- Titulo -->
            <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
              <div>
                  <v-icon class="mb-1" left>fas fa-filter</v-icon>
                  Filtros
                </div>
                <template v-slot:actions>
                  <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                    <v-icon>fas fa-chevron-down</v-icon>
                  </v-btn>
                </template>
            </v-expansion-panel-header>
            <!-- Filtros -->
            <v-expansion-panel-content>
              <v-form @submit.prevent="buscar">
                <v-row :no-gutters="$vuetify.breakpoint.xs">
                  <!-- <v-col cols="12" sm="2" md="2" class="py-1">
                    Empresa
                    <v-autocomplete
                      v-model="filtro.empresa_id"
                      item-text="nombre_corto"
                      item-value="id"
                      :items="empresas"
                      hide-details
                      outlined
                      dense
                      clearable
                      @change="getCuotas()"
                    ></v-autocomplete>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="6" class="py-1">
                    Tarjeta
                    <v-autocomplete
                      v-model="filtro.select_tarjetas"
                      item-text="tarjeta_nombre"
                      item-value="tarjeta_codigo"
                      :items="tarjetas"
                      hide-details
                      outlined
                      dense
                      multiple
                      clearable
                      chips
                      deletable-chips
                      @change="getCuotas()"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="py-1">
                    Cuota
                    <v-autocomplete
                      v-model="filtro.select_cuotas"
                      :item-text="cuotasNombre"
                      item-value="cuotas_id"
                      :items="cuotas"
                      hide-details
                      outlined
                      dense
                      multiple
                      clearable
                      chips
                      deletable-chips
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row :no-gutters="$vuetify.breakpoint.xs">
                  <v-col cols="12" sm="6" md="6" class="py-1">
                    Forma Pago
                    <v-autocomplete
                      v-model="filtro.select_forma_pago"
                      item-text="nombre"
                      item-value="id"
                      :items="fornasPago"
                      hide-details
                      outlined
                      dense
                      multiple
                      clearable
                      chips
                      deletable-chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="py-1">
                    Forma Cobro
                    <v-autocomplete
                      v-model="filtro.select_forma_cobro"
                      item-text="nombre"
                      item-value="id"
                      :items="fornasCobro"
                      hide-details
                      outlined
                      dense
                      multiple
                      clearable
                      chips
                      deletable-chips
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row :no-gutters="$vuetify.breakpoint.xs">
                  <v-col cols="12" sm="2" md="2" class="py-1">
                    Vig. Desde
                    <FechaPicker
                      v-model="filtro.vigencia_desde"
                      :hideDetails="true"
                      :clearable="true"
                    />
                  </v-col>
                  <v-col cols="12" sm="2" md="2" class="py-1">
                    Vig. Hasta
                    <FechaPicker
                      v-model="filtro.vigencia_hasta"
                      :hideDetails="true"
                      :clearable="true"
                    />
                  </v-col>
                  <v-col cols="12" sm="2" md="2" class="mt-3">
                    <v-checkbox
                      v-model="filtro.inhabilitado"
                      dense
                      hide-details
                      :true-value="1"
                      :false-value="0"
                      label="Inhabilitadas"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6" class="py-1">
                    <BtnFiltro
                      :loading="load"
                      @clear="limpiar()"
                      clase="mt-0"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- Costos Financieros -->
        <v-row :no-gutters="$vuetify.breakpoint.xs">
          <v-col cols="12">
            <v-data-table
              class="cebra elevation-2 mt-2"
              :headers="headers"
              :items="costosFin"
              :loading="load"
              dense
              :search="search"
              sort-by="cuotas_nombre"
              :sort-desc="false"
            >
              <!-- Buscador en el datatable -->
              <template v-slot:top>
                <v-row class="d-flex justify-end pa-2" no-gutters>
                  <v-col cols="6" sm="3">
                    <SearchDataTable
                      v-model="search"
                    />
                  </v-col>
                </v-row>
              </template>
              <!-- Msj que se mostrara si no existen resultados -->
              <template v-slot:no-data>
                <v-alert
                  class="mx-auto mt-4"
                  max-width="400"
                  type="warning"
                  border="left"
                  dense
                  text
                >
                  Sin Costos para mostrar.
                </v-alert>
              </template>
              <!-- Vigencias -->
              <template v-slot:[`item.vigencia_desde`]="{ item }">
                {{ format_date(item.vigencia_desde) }}
              </template>
              <template v-slot:[`item.vigencia_hasta`]="{ item }">
                {{ format_date(item.vigencia_hasta) }}
              </template>
              <!-- Porcentaje -->
              <template v-slot:[`item.porcentaje`]="{ item }">
                {{ Intl.NumberFormat("de-DE").format(roundNumber(item.porcentaje, 3) * 100) }}%
              </template>
              <!-- Costos Financieros -->
              <template v-slot:[`item.costo_f_con_inf`]="{ item }">
                <span :class="getColor(item)">{{ Intl.NumberFormat("de-DE").format(roundNumber(item.costo_f_con_inf, 2)) }}%</span>
              </template>
              <template v-slot:[`item.rdo_f_con_inf`]="{ item }">
                {{ Intl.NumberFormat("de-DE").format(roundNumber(item.rdo_f_con_inf, 2)) }}%
              </template>
              <template v-slot:[`item.costo_f_sin_inf`]="{ item }">
                <span :class="getColor(item)">{{ Intl.NumberFormat("de-DE").format(roundNumber(item.costo_f_sin_inf, 2)) }}%</span>
              </template>
              <template v-slot:[`item.rdo_f_sin_inf`]="{ item }">
                {{ Intl.NumberFormat("de-DE").format(roundNumber(item.rdo_f_sin_inf, 2)) }}%
              </template>
              <!-- Acciones -->
              <template v-slot:[`item.acciones`]="{ item }">
                <div class="d-flex justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small icon color="info" @click="empezarSimulacion(item)" v-on="on">
                        <v-icon small>fas fa-cube</v-icon>
                      </v-btn>
                    </template>
                    <span>Simular</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- Sección Costo Financiero Seleccionado -->
        <v-row :no-gutters="$vuetify.breakpoint.xs">
          <v-col
            cols="12" 
            class="pt-0"
          >
            <v-expand-transition>
              <section id="unCostoFinanciero">
                <v-card
                  flat
                  v-if="selected.length > 0"
                >
                  <v-card-title class="d-flex justify-end pb-0 pt-1 px-2">
                    <v-btn
                      title="Cerrar detalle"
                      icon
                      small
                      @click="selected = []"
                    >
                      <v-icon>fas fa-times</v-icon>
                    </v-btn>
                  </v-card-title>
                  <!-- Datos de los CF seleccionados -->
                  <v-card-text class="pt-0 px-0" style="width: 100%">
                    <!-- Listado -->
                    <v-data-table
                      class="mb-2"
                      style="width: 100%"
                      :headers="headerSelect"
                      :items="selected"
                      hide-default-footer
                      sort-desc
                      dense
                    >
                      <!-- Vigencias -->
                      <template v-slot:[`item.vigencia_desde`]="{ item }">
                        {{ format_date(item.vigencia_desde) }}
                      </template>
                      <template v-slot:[`item.vigencia_hasta`]="{ item }">
                        {{ format_date(item.vigencia_hasta) }}
                      </template>
                      <!-- Porcentaje -->
                      <template v-slot:[`item.porcentaje`]="{ item }">
                        {{ Intl.NumberFormat("de-DE").format(roundNumber(item.porcentaje, 3) * 100) }}%
                      </template>
                      <!-- Costos Financieros -->
                      <template v-slot:[`item.costo_f_con_inf`]="{ item }">
                        <span :class="getColor(item)">{{ Intl.NumberFormat("de-DE").format(roundNumber(item.costo_f_con_inf, 2)) }}%</span>
                      </template>
                      <template v-slot:[`item.rdo_f_con_inf`]="{ item }">
                        {{ Intl.NumberFormat("de-DE").format(roundNumber(item.rdo_f_con_inf, 2)) }}%
                      </template>
                      <template v-slot:[`item.costo_f_sin_inf`]="{ item }">
                        <span :class="getColor(item)">{{ Intl.NumberFormat("de-DE").format(roundNumber(item.costo_f_sin_inf, 2)) }}%</span>
                      </template>
                      <template v-slot:[`item.rdo_f_sin_inf`]="{ item }">
                        {{ Intl.NumberFormat("de-DE").format(roundNumber(item.rdo_f_sin_inf, 2)) }}%
                      </template>
                    </v-data-table>
                    <!-- Simulación -->
                    <v-row :no-gutters="$vuetify.breakpoint.xs">
                      <v-col cols="12" sm="6">
                        <v-card
                          flat
                          outlined
                        >
                          <v-card-title>
                            Resultado Financiero
                          </v-card-title>
                          <v-card-text>
                            <v-row :no-gutters="$vuetify.breakpoint.xs">
                              <v-col cols="12">
                                <v-simple-table dense>
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th class="text-left">Resultado Económico</th>
                                        <th class="text-right">Monto</th>
                                        <th class="text-right">Porcentajes Nominales</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr 
                                        v-for="item in costosEdit"
                                        :key="item.index"
                                        :class="item.negrita == 1 ? ($vuetify.theme.dark ? 'color-fila-dark' : 'color-fila-ligth') : ''"
                                      >
                                        <td class="text-left"><div :class="item.sangria == 1 ? 'ml-6' : ''">{{ item.titulo }}</div></td>
                                        <td class="text-right">
                                          <div v-if="item.index == 0">
                                            <TextFieldMoney 
                                              v-model="item.monto"
                                              outlined
                                              dense
                                              :id="montoBase"
                                              :ref="montoBase"
                                              @blur="simular()"
                                              v-bind:properties="{
                                                prefix: '$', 'hide-details': true,
                                                'readonly': boolString == 'false',
                                                'filled': boolString == 'false',
                                              }"
                                            />
                                          </div>
                                          <div v-else>{{ format_money(roundNumber(item.monto, 2)) }}</div>
                                        </td>
                                        <td class="text-right">
                                          <TextFieldMoney 
                                            v-model="item.porcentaje_nominal"
                                            outlined
                                            dense
                                            :id="porcentaje"
                                            :ref="porcentaje"
                                            @blur="simular()"
                                            v-bind:properties="{
                                              suffix: '%', 'hide-details': true,
                                              'readonly': item.edita_porcentaje == 0 ? true : false,
                                              'filled': item.edita_porcentaje == 0 ? boolString == 'true' : boolString == 'false',
                                            }"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>
                              <v-col cols="12">
                                <v-data-table
                                  class="cebra elevation-2"
                                  :headers="headersCFconINF"
                                  :items="cfConInf"
                                  dense
                                  hide-default-footer
                                >
                                  <!-- Monto -->
                                  <template v-slot:[`item.monto`]="{ item }">
                                    {{ format_money(roundNumber(item.monto, 2)) }}
                                  </template>
                                  <!-- Porcentaje -->
                                  <template v-slot:[`item.porcentaje`]="{ item }">
                                    {{ Intl.NumberFormat("de-DE").format(roundNumber(item.porcentaje, 2)) }}%
                                  </template>
                                  <!-- Acciones -->
                                  <template v-slot:[`item.acciones`]="{ item }">
                                    <v-tooltip bottom v-if="item.descripcion.indexOf('Resultado') != -1">
                                      <template v-slot:activator="{ on }">
                                        <v-btn small icon color="info" @click="resSinInf = 0; dialogObj = true" v-on="on">
                                          <v-icon small>fas fa-chart-line</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Buscar Objetivo</span>
                                    </v-tooltip>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-card
                          flat
                          outlined
                        >
                          <v-card-title>
                            Resultado Económico
                          </v-card-title>
                          <v-card-text>
                            <v-row :no-gutters="$vuetify.breakpoint.xs">
                              <v-col cols="12">
                                <v-simple-table dense>
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th class="text-left">Resultado Económico</th>
                                        <th class="text-right">Monto</th>
                                        <th class="text-right">Porcentajes Nominales</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr 
                                        v-for="item in costosNoEdit"
                                        :key="item.index"
                                        :class="item.negrita == 1 ? ($vuetify.theme.dark ? 'color-fila-dark' : 'color-fila-ligth') : ''"
                                      >
                                        <td class="text-left"><div :class="item.sangria == 1 ? 'ml-6' : ''">{{ item.titulo }}</div></td>
                                        <td class="text-right">{{ format_money(roundNumber(item.monto, 2)) }}</td>
                                        <!-- <td class="text-right">{{ Intl.NumberFormat("de-DE").format(roundNumber(item.porcentaje_nominal, 4)) }}%</td> -->
                                         <td class="text-right">
                                          <TextFieldMoney 
                                            v-model="item.porcentaje_nominal"
                                            outlined
                                            dense
                                            :id="porcentaje"
                                            :ref="porcentaje"
                                            @blur="simular()"
                                            v-bind:properties="{
                                              suffix: '%', 'hide-details': true,
                                              'readonly': true,
                                              'filled': boolString == 'true',
                                            }"
                                          />
                                         </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>
                              <v-col cols="12">
                                <v-data-table
                                  class="cebra elevation-2"
                                  :headers="headersCFsinINF"
                                  :items="cfSinInf"
                                  dense
                                  hide-default-footer
                                >
                                  <!-- Monto -->
                                  <template v-slot:[`item.monto`]="{ item }">
                                    {{ format_money(roundNumber(item.monto, 2)) }}
                                  </template>
                                  <!-- Porcentaje -->
                                  <template v-slot:[`item.porcentaje`]="{ item }">
                                    {{ Intl.NumberFormat("de-DE").format(roundNumber(item.porcentaje, 2)) }}%
                                  </template>
                                  <!-- Acciones -->
                                  <template v-slot:[`item.acciones`]="{ item }">
                                    <v-tooltip bottom v-if="item.descripcion.indexOf('Resultado') != -1">
                                      <template v-slot:activator="{ on }">
                                        <v-btn small icon color="info" @click="resSinInf = 1; dialogObj = true" v-on="on">
                                          <v-icon small>fas fa-chart-line</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Buscar Objetivo</span>
                                    </v-tooltip>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </section>
            </v-expand-transition>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Modal Ingresar Objetivo Esperado -->
    <v-dialog
      v-model="dialogObj"
      max-width="200"
    >
      <v-card
        flat
      >
        <v-card-title>
          <div class="d-flex align-center">
            <p class="text-center" style="font-size:small; word-break: normal; line-height: normal;">Ingresar el Objetivo Esperado</p>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogObj = false; objetivo = 0"><v-icon title="Cerrar">fas fa-times</v-icon></v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12" class="py-1">
              <TextFieldMoney 
                v-model="objetivo"
                outlined
                dense
                :id="objRef"
                :ref="objRef"
                @keypress.native.enter="simular(1)"
                v-bind:properties="{
                  suffix: '%', 
                  'hide-details': true,
                  'readonly': false,
                  'filled': boolString == 'false',
                  'autofocus': boolString == 'true',
                }"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cadenaVacia, arrayVacio, format_date, roundNumber, format_money, order_list_by } from '../../util/utils'
import FechaPicker from '../../components/util/FechaPicker.vue'
import BtnFiltro from '../../components/util/BtnFiltro.vue'
import SearchDataTable from '../../components/util/SearchDataTable.vue'
import TextFieldMoney from '../../components/util/TextFieldMoney.vue'
import { ref } from 'vue'
export default {
  data() {
    return {
      format_date: format_date,
      roundNumber: roundNumber,
      format_money: format_money,
      porcentaje: 'porcentaje',
      montoBase: 'montoBase',
      panel: 0,
      filtro: {
        empresa_id: 2,
        select_tarjetas: null,
        select_cuotas: null,
        select_forma_pago: null,
        select_forma_cobro: null,
        vigencia_desde: null,
        vigencia_hasta: null,
        inhabilitado: 0
      },
      empresas: [],
      tarjetas: [],
      cuotas: [],
      cuotasTodas: [],
      fornasPago: [],
      fornasCobro: [],
      load: false,
      headers: [
        { text: 'Id', align: 'center', value: 'id' },
        { text: 'Nombre', align: 'left', value: 'descripcion' },
        { text: 'Tarjeta', align: 'left', value: 'nombre_tarjeta' },
        { text: 'Cuota', align: 'left', value: 'cuotas_nombre' },
        { text: 'F. Cobro', align: 'left', value: 'forma_cobro' },
        { text: 'Vig. Desde', align: 'left', value: 'vigencia_desde' },
        { text: 'Vig. Hasta', align: 'left', value: 'vigencia_hasta' },
        { text: '%', align: 'right', value: 'porcentaje' },
        { text: 'C. Fin c/Inf', align: 'right', value: 'costo_f_con_inf' },
        { text: 'Rdo. Fin c/Inf', align: 'right', value: 'rdo_f_con_inf' },
        { text: 'C. Fin s/Inf', align: 'right', value: 'costo_f_sin_inf' },
        { text: 'Rdo Fin s/Inf', align: 'right', value: 'rdo_f_sin_inf' },
        { text: '', align: 'center', value: 'acciones' }
      ],
      headerSelect: [
        { text: 'Id', align: 'center', value: 'id' },
        { text: 'Nombre', align: 'left', value: 'descripcion' },
        { text: 'Tarjeta', align: 'left', value: 'nombre_tarjeta' },
        { text: 'Cuota', align: 'left', value: 'cuotas_nombre' },
        { text: 'F. Cobro', align: 'left', value: 'forma_cobro' },
        { text: 'Vig. Desde', align: 'left', value: 'vigencia_desde' },
        { text: 'Vig. Hasta', align: 'left', value: 'vigencia_hasta' },
        { text: '%', align: 'right', value: 'porcentaje' },
        { text: 'C. Fin c/Inf', align: 'right', value: 'costo_f_con_inf' },
        { text: 'Rdo. Fin c/Inf', align: 'right', value: 'rdo_f_con_inf' },
        { text: 'C. Fin s/Inf', align: 'right', value: 'costo_f_sin_inf' },
        { text: 'Rdo Fin s/Inf', align: 'right', value: 'rdo_f_sin_inf' }
      ],
      costosEdit: [],
      costosNoEdit: [],
      costosFin: [],
      search: '',
      selected: [],
      boolString: 'true',
      headersCFsinINF: [
        { text: '', align: 'left', value: 'descripcion' },
        { text: '', align: 'right', value: 'monto' },
        { text: '', align: 'right', value: 'porcentaje' },
        { text: '', align: 'center', value: 'acciones' }
      ],
      cfSinInf: [],
      headersCFconINF: [
        { text: '', align: 'left', value: 'descripcion' },
        { text: '', align: 'right', value: 'monto' },
        { text: '', align: 'right', value: 'porcentaje' },
        { text: '', align: 'center', value: 'acciones' }
      ],
      cfConInf: [],
      dialogObj: false,
      objetivo: 0,
      resSinInf: 0,
      objRef: 'objRef'
    }
  },
  components: {
    FechaPicker,
    BtnFiltro,
    SearchDataTable,
    TextFieldMoney
  },
  created () {
    this.initForm()
  },
  methods: {
    getColor(){
      if (this.$vuetify.theme.dark) return 'color-green-dark'
      else return 'color-green-ligth'
    },
    async initForm(){
      this.empresas = JSON.parse(localStorage.getItem('empresas'))
      this.$store.state.loading = true
      let initPeticion = await this.$store.dispatch('costosFinancieros/initCostosFinancieros')
      this.$store.state.loading = false
      if (initPeticion.resultado == 0){
        this.$store.dispatch('show_snackbar', {
          text: initPeticion.msj,
          color: 'error',
        })
        return
      }
      this.tarjetas = initPeticion.tarjetas
      this.cuotasTodas = initPeticion.cuotas
      this.fornasPago = initPeticion.formas_pago
      this.fornasCobro = initPeticion.formas_cobro
    },
    getCuotas(){
      if (cadenaVacia(this.filtro.empresa_id) || arrayVacio(this.filtro.select_tarjetas)){
        this.filtro.select_cuotas = []
        this.cuotas = []
        return
      }
      this.cuotas = []
      for (let jd in this.filtro.select_tarjetas){
        let tarCuotas = this.cuotasTodas.filter(element => element.empresa_id == this.filtro.empresa_id && element.tarjeta_codigo == this.filtro.select_tarjetas[jd])
        if (tarCuotas.length > 0){
          for (let kd in tarCuotas){
            let existe = this.cuotas.filter(element => element.cuotas_id == tarCuotas[kd].cuotas_id)
            if (existe.length == 0) this.cuotas.push(tarCuotas[kd])
          }
        }
      }
    },
    cuotasNombre(item){
      if (cadenaVacia(this.filtro.empresa_id) || arrayVacio(this.filtro.select_tarjetas)) return
      if (this.filtro.select_tarjetas.length == 1) return item.cuotas_nombre
      if (this.filtro.select_tarjetas.length > 1) return `${this.tarjetas.filter(element => element.tarjeta_codigo == item.tarjeta_codigo)[0].tarjeta_nombre} - ${item.cuotas_nombre}`
    },
    async buscar(){
      if (cadenaVacia(this.filtro.empresa_id)) return
      this.search = ''
      this.selected = []
      this.costosFin = []
      this.load = true
      let buscarPeticion = await this.$store.dispatch('costosFinancieros/getCostosFinancieros', this.filtro)
      this.load = false
      if (buscarPeticion.resultado == 0){
        this.$store.dispatch('show_snackbar', {
          text: buscarPeticion.msj,
          color: 'error',
        })
        return
      }
      this.costosFin = buscarPeticion.costos_financieros
    },
    limpiar(){
      this.filtro = {
        empresa_id: 2,
        select_tarjetas: null,
        select_cuotas: null,
        select_forma_pago: null,
        select_forma_cobro: null,
        vigencia_desde: null,
        vigencia_hasta: null,
        inhabilitado: 0
      }
      this.search = ''
    },
    empezarSimulacion(item){
      this.selected = []
      // asigno el item
      this.selected.push(item)
      // armo los listados para que empiecen a simular
      this.initSimulacion()
      // this.$vuetify.goTo('#unCostoFinanciero')
    },
    initSimulacion(){
      // lleno los datatable de resumen
      this.cfSinInf = []
      this.cfConInf = []
      for (let id = 0; id <= 1; id++){
        let unObj = {
          descripcion: id == 0 ? 'Costo Financiación s/Inflación s/VTA NETA' : 'Resultado Económico s/Inflación s/IVA',
          monto: null,
          porcentaje: null,
          index: parseInt(id)
        }
        this.cfSinInf.push(unObj)
      }
      this.cfConInf = JSON.parse(JSON.stringify(this.cfSinInf))
      this.cfConInf[0].descripcion = 'Costo Financiación c/Inflación s/VTA NETA'
      this.cfConInf[1].descripcion = 'Resultado Económico c/Inflación s/IVA'
      // sigo con las tarjetas para la simulación
      this.costosEdit = []
      this.costosNoEdit = []
      let totalRecargo = 0
      let montoCobrarCliente = 0
      let arancel = 0
      let costoFinanciero = 0
      let bonificaciones = 0
      let ivaArancel = 0
      let ivaCF = 0
      let ivaBonif = 0
      let montoCosto = 0
      let montoLiqCheque = 0
      let costoCheques = 0
      let montoLiq = 0
      let impDebCred = 0
      let montoAcred = 0
      for (let id = 0; id <= 19; id++){
        let unObj = {titulo: '', monto: 0, index: 0, porcentaje_nominal: 0, negrita: 0, sangria: 0, edita_porcentaje: 1}
        if (id == 0){
          unObj.monto = 100000
          unObj.porcentaje_nominal = 100
          unObj.titulo = 'Precio de Contado'
          unObj.index = parseInt(id)
          unObj.negrita = 1
          unObj.edita_porcentaje = 0
        }
        if (id == 1){
          unObj.titulo = 'Recargo de la Operación'
          unObj.index = parseInt(id)
          unObj.porcentaje_nominal = roundNumber(this.selected[0].porcentaje * 100, 6)
          unObj.monto = roundNumber(100000 * this.selected[0].porcentaje, 6)
          totalRecargo = roundNumber(100000 * this.selected[0].porcentaje, 6)
        }
        if (id == 2){
          unObj.titulo = 'Monto a Cobrar al Cliente'
          unObj.index = parseInt(id)
          unObj.monto = 100000 + totalRecargo
          unObj.porcentaje_nominal = 100
          unObj.negrita = 1
          unObj.edita_porcentaje = 0
          montoCobrarCliente = 100000 + totalRecargo
        }
        if (id == 3){
          unObj.titulo = 'Arancel'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].arancel, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(montoCobrarCliente * this.selected[0].arancel, 6)
          arancel = roundNumber(montoCobrarCliente * this.selected[0].arancel, 6)
        }
        if (id == 4){
          unObj.titulo = 'Costo Financiero'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].costo_financiero, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(montoCobrarCliente * this.selected[0].costo_financiero, 6)
          costoFinanciero = roundNumber(montoCobrarCliente * this.selected[0].costo_financiero, 6)
        }
        if (id == 5){
          unObj.titulo = 'Bonificación'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].bonificaciones, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(montoCobrarCliente * this.selected[0].bonificaciones, 6)
          bonificaciones = roundNumber(montoCobrarCliente * this.selected[0].bonificaciones, 6)
        }
        if (id == 6){
          unObj.titulo = 'Iva Arancel'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].iva_arancel, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(arancel * this.selected[0].iva_arancel, 6)
          ivaArancel = roundNumber(arancel * this.selected[0].iva_arancel, 6)
        }
        if (id == 7){
          unObj.titulo = 'Iva CF'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].iva_cf, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(costoFinanciero * this.selected[0].iva_cf, 6)
          ivaCF = roundNumber(costoFinanciero * this.selected[0].iva_cf, 6)
        }
        if (id == 8){
          unObj.titulo = 'Iva Bonificaciones'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].iva_bonif, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(bonificaciones * this.selected[0].iva_bonif, 6)
          ivaBonif = roundNumber(bonificaciones * this.selected[0].iva_bonif, 6)
        }
        if (id == 9){
          unObj.titulo = 'IB sobre el Recargo'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].ibb, 6) * 100, 6)
          unObj.monto = roundNumber(totalRecargo * this.selected[0].ibb, 6)
        }
        if (id == 10){
          unObj.titulo = 'Imp. Actividades Varias s/Recargo'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].imp_act_varias, 6) * 100, 6)
          unObj.monto = roundNumber(totalRecargo * this.selected[0].imp_act_varias, 6)
        }
        if (id == 11){
          unObj.titulo = 'Imp. a las Ganancias s/Recargo'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].imp_ganancias, 6) * 100, 6)
          unObj.monto = roundNumber(totalRecargo * this.selected[0].imp_ganancias, 6)
        }
        if (id == 12){
          unObj.titulo = 'Monto Costo'
          unObj.index = parseInt(id)
          unObj.monto = (-1) * roundNumber(arancel + costoFinanciero + bonificaciones + ivaArancel + ivaCF + ivaBonif, 6)
          unObj.porcentaje_nominal = Math.abs(roundNumber((unObj.monto / montoCobrarCliente) * 100, 6))
          montoCosto = (-1) * roundNumber(arancel + costoFinanciero + bonificaciones + ivaArancel + ivaCF + ivaBonif, 6)
          unObj.edita_porcentaje = 0
        }
        if (id == 13){
          unObj.titulo = 'Monto Liquidado antes de Cheque'
          unObj.index = parseInt(id)
          unObj.negrita = 1
          unObj.monto = roundNumber(montoCobrarCliente + montoCosto, 6)
          unObj.porcentaje_nominal = roundNumber((unObj.monto / 100000) * 100, 6)
          montoLiqCheque = roundNumber(montoCobrarCliente + montoCosto, 6)
          unObj.edita_porcentaje = 0
        }
        if (id == 14){
          unObj.titulo = 'Costo de Cheques'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].cheques, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(montoLiqCheque * this.selected[0].cheques, 6)
          costoCheques = (-1) * roundNumber(montoLiqCheque * this.selected[0].cheques, 6)
        }
        if (id == 15){
          unObj.titulo = 'Monto Liquidado'
          unObj.index = parseInt(id)
          unObj.negrita = 1
          unObj.monto = roundNumber(costoCheques + montoLiqCheque, 6)
          unObj.porcentaje_nominal = roundNumber((unObj.monto / montoCobrarCliente) * 100, 6)
          montoLiq = roundNumber(costoCheques + montoLiqCheque, 6)
          unObj.edita_porcentaje = 0
        }
        if (id == 16){
          unObj.titulo = 'Imp. Débito y Crédito'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].deb_cred, 6) * 100, 6)
          unObj.monto = (-1) * roundNumber(montoLiq * this.selected[0].deb_cred, 6)
          impDebCred = (-1) * roundNumber(montoLiq * this.selected[0].deb_cred, 6)
        }
        if (id == 17){
          unObj.titulo = 'Monto Acreditado'
          unObj.index = parseInt(id)
          unObj.negrita = 1
          unObj.monto = roundNumber(montoLiq + impDebCred, 6)
          unObj.porcentaje_nominal = roundNumber((unObj.monto / 100000) * 100, 6)
          montoAcred = roundNumber(montoLiq + impDebCred, 6)
          unObj.edita_porcentaje = 0
        }
        if (id == 18){
          unObj.titulo = 'Costo Inflacionario Diario'
          unObj.index = parseInt(id)
          unObj.sangria = 1
          unObj.porcentaje_nominal = roundNumber(roundNumber(this.selected[0].inflacion, 6) * 100, 6)
          unObj.monto = roundNumber(montoAcred * this.selected[0].inflacion, 6)
        }
        if (id == 19){
          unObj.titulo = 'Monto Final por Inflación'
          unObj.index = parseInt(id)
          unObj.negrita = 1
          unObj.monto = montoAcred
          unObj.porcentaje_nominal = roundNumber((unObj.monto / 100000) * 100, 6)
          unObj.edita_porcentaje = 0
        }
        this.costosEdit.push(unObj)
      }
      this.costosNoEdit = JSON.parse(JSON.stringify(this.costosEdit))
      order_list_by(this.costosEdit, 'index', 'asc')
      order_list_by(this.costosNoEdit, 'index', 'asc')
      order_list_by(this.cfSinInf, 'index', 'asc')
      order_list_by(this.cfConInf, 'index', 'asc')
      this.simular()
      this.$vuetify.goTo('#unCostoFinanciero')
    },
    simular(opcion){
      // 06-06-2025 por MMURILLO, permitimos recalcular todo según un objetivo esperado
      if (!cadenaVacia(opcion) && cadenaVacia(this.objetivo)) return
      if (!cadenaVacia(opcion)) this.dialogObj = false
      // 24-06-2025 por MMURILLO, permitimos modificar el monto inicial, recalculamos segun ese importe, el porcentaje siempre va a ser 100%
      this.costosEdit[0].monto = roundNumber(this.costosEdit[0].monto, 2)
      this.costosNoEdit[0].monto = roundNumber(this.costosEdit[0].monto, 2)
      // acomodo los datos ingresados, RECARGO DE LA OPERACION
      this.costosEdit[1].porcentaje_nominal = roundNumber(this.costosEdit[1].porcentaje_nominal, 6)
      this.costosEdit[1].monto = roundNumber(this.costosEdit[0].monto * (this.costosEdit[1].porcentaje_nominal / 100), 6)
      this.costosNoEdit[1].porcentaje_nominal = roundNumber(this.costosEdit[1].porcentaje_nominal, 6)
      this.costosNoEdit[1].monto = roundNumber(this.costosEdit[0].monto * (this.costosNoEdit[1].porcentaje_nominal / 100), 6)
      // RECARGO SIN IVA
      let recargo_s_iva = roundNumber(this.costosEdit[1].monto / 1.21, 6)
      // MONTO A COBRAR AL CLIENTE
      this.costosEdit[2].monto = roundNumber(this.costosEdit[0].monto + this.costosEdit[1].monto, 6)
      this.costosNoEdit[2].monto = roundNumber(this.costosNoEdit[0].monto + this.costosNoEdit[1].monto, 6)
      // ARANCEL
      this.costosEdit[3].porcentaje_nominal = roundNumber(this.costosEdit[3].porcentaje_nominal, 6)
      this.costosEdit[3].monto = (-1) * roundNumber(this.costosEdit[2].monto * (this.costosEdit[3].porcentaje_nominal / 100), 6)
      this.costosNoEdit[3].porcentaje_nominal = roundNumber(this.costosEdit[3].porcentaje_nominal, 6)
      this.costosNoEdit[3].monto = (-1) * roundNumber(this.costosNoEdit[2].monto * (this.costosNoEdit[3].porcentaje_nominal / 100), 6)
      // COSTO FINANCIERO
      this.costosEdit[4].porcentaje_nominal = roundNumber(this.costosEdit[4].porcentaje_nominal, 6)
      this.costosEdit[4].monto = (-1) * roundNumber(this.costosEdit[2].monto * (this.costosEdit[4].porcentaje_nominal / 100), 6)
      this.costosNoEdit[4].porcentaje_nominal = roundNumber(this.costosEdit[4].porcentaje_nominal, 6)
      this.costosNoEdit[4].monto = (-1) * roundNumber(this.costosNoEdit[2].monto * (this.costosNoEdit[4].porcentaje_nominal / 100), 6)
      // BONIFICACION
      this.costosEdit[5].porcentaje_nominal = roundNumber(this.costosEdit[5].porcentaje_nominal, 6)
      this.costosEdit[5].monto = (-1) * roundNumber(this.costosEdit[2].monto * (this.costosEdit[5].porcentaje_nominal / 100), 6)
      this.costosNoEdit[5].porcentaje_nominal = roundNumber(this.costosEdit[5].porcentaje_nominal, 6)
      this.costosNoEdit[5].monto = (-1) * roundNumber(this.costosNoEdit[2].monto * (this.costosNoEdit[5].porcentaje_nominal / 100), 6)
      // IVA ARANCEL
      this.costosEdit[6].porcentaje_nominal = roundNumber(this.costosEdit[6].porcentaje_nominal, 6)
      this.costosEdit[6].monto = roundNumber(this.costosEdit[3].monto * (this.costosEdit[6].porcentaje_nominal / 100), 6)
      this.costosNoEdit[6].porcentaje_nominal = 0
      this.costosNoEdit[6].monto = 0
      // IVA COSTO FINANCIERO
      this.costosEdit[7].porcentaje_nominal = roundNumber(this.costosEdit[7].porcentaje_nominal, 6)
      this.costosEdit[7].monto = roundNumber(this.costosEdit[4].monto * (this.costosEdit[7].porcentaje_nominal / 100), 6)
      this.costosNoEdit[7].porcentaje_nominal = 0
      this.costosNoEdit[7].monto = 0
      // IVA BONIFICACIONES
      this.costosEdit[8].porcentaje_nominal = roundNumber(this.costosEdit[8].porcentaje_nominal, 6)
      this.costosEdit[8].monto = roundNumber(this.costosEdit[5].monto * (this.costosEdit[8].porcentaje_nominal / 100), 6)
      this.costosNoEdit[8].porcentaje_nominal = 0
      this.costosNoEdit[8].monto = 0
      // IB SOBRE EL RECARGO
      this.costosEdit[9].porcentaje_nominal = roundNumber(this.costosEdit[9].porcentaje_nominal, 6)
      this.costosEdit[9].monto = (-1) * roundNumber(this.costosEdit[1].monto * (this.costosEdit[9].porcentaje_nominal / 100), 6)
      this.costosNoEdit[9].porcentaje_nominal = roundNumber(this.costosEdit[9].porcentaje_nominal, 6)
      this.costosNoEdit[9].monto = (-1) * roundNumber((this.costosNoEdit[1].monto / 1.21) * (this.costosNoEdit[9].porcentaje_nominal / 100), 6)
      // IMP. ACTIVIDADES VARIAS S/RECARGO
      this.costosEdit[10].porcentaje_nominal = roundNumber(this.costosEdit[10].porcentaje_nominal, 6)
      this.costosEdit[10].monto = (-1) * roundNumber(this.costosEdit[1].monto * (this.costosEdit[10].porcentaje_nominal / 100), 6)
      this.costosNoEdit[10].porcentaje_nominal = roundNumber(this.costosEdit[10].porcentaje_nominal, 6)
      this.costosNoEdit[10].monto = (-1) * roundNumber((this.costosNoEdit[1].monto / 1.21) * (this.costosNoEdit[10].porcentaje_nominal / 100), 6)
      // IMP. A LAS GANANCIAS S/RECARGO
      this.costosEdit[11].porcentaje_nominal = roundNumber(this.costosEdit[11].porcentaje_nominal, 6)
      this.costosEdit[11].monto = (-1) * roundNumber(this.costosEdit[1].monto * (this.costosEdit[11].porcentaje_nominal / 100), 6)
      this.costosNoEdit[11].porcentaje_nominal = roundNumber(this.costosEdit[11].porcentaje_nominal, 6)
      this.costosNoEdit[11].monto = (-1) * roundNumber((this.costosNoEdit[1].monto / 1.21) * (this.costosNoEdit[11].porcentaje_nominal / 100), 6)
      // MONTO COSTO
      this.costosEdit[12].monto = this.costosEdit.filter(element => element.index >= 3 && element.index <= 11).reduce((sum, costo) => sum + roundNumber(costo.monto, 6), 0)
      this.costosEdit[12].porcentaje_nominal = Math.abs(roundNumber((this.costosEdit[12].monto / this.costosEdit[2].monto) * 100, 6))
      this.costosNoEdit[12].monto = this.costosNoEdit.filter(element => element.index >= 3 && element.index <= 11).reduce((sum, costo) => sum + roundNumber(costo.monto, 6), 0)
      this.costosNoEdit[12].porcentaje_nominal = Math.abs(roundNumber((this.costosNoEdit[12].monto / this.costosNoEdit[2].monto) * 100, 6))
      // MONTO LIQUIDADO ANTES DE CHEQUE
      this.costosEdit[13].monto = roundNumber(this.costosEdit[2].monto + this.costosEdit[12].monto, 6)
      this.costosEdit[13].porcentaje_nominal = roundNumber((this.costosEdit[13].monto / this.costosEdit[0].monto) * 100, 6)
      this.costosNoEdit[13].monto = roundNumber(this.costosNoEdit[2].monto + this.costosNoEdit[12].monto, 6)
      this.costosNoEdit[13].porcentaje_nominal = roundNumber((this.costosNoEdit[13].monto / this.costosNoEdit[0].monto) * 100, 6)
      // COSTO DE CHEQUES
      this.costosEdit[14].porcentaje_nominal = roundNumber(this.costosEdit[14].porcentaje_nominal, 6)
      this.costosEdit[14].monto = (-1) * roundNumber(this.costosEdit[13].monto * (this.costosEdit[14].porcentaje_nominal / 100), 6)
      this.costosNoEdit[14].porcentaje_nominal = roundNumber(this.costosEdit[14].porcentaje_nominal, 6)
      this.costosNoEdit[14].monto = (-1) * roundNumber(this.costosEdit[13].monto * (this.costosNoEdit[14].porcentaje_nominal / 100), 6)
      // MONTO LIQUIDADO
      this.costosEdit[15].monto = roundNumber(this.costosEdit[13].monto + this.costosEdit[14].monto, 6)
      this.costosEdit[15].porcentaje_nominal = roundNumber((this.costosEdit[15].monto / this.costosEdit[2].monto) * 100, 6)
      this.costosNoEdit[15].monto = roundNumber(this.costosNoEdit[13].monto + this.costosNoEdit[14].monto, 6)
      this.costosNoEdit[15].porcentaje_nominal = roundNumber((this.costosNoEdit[15].monto / this.costosNoEdit[2].monto) * 100, 6)
      // IMP DEBITO Y CREDITO
      this.costosEdit[16].porcentaje_nominal = roundNumber(this.costosEdit[16].porcentaje_nominal, 6)
      this.costosEdit[16].monto = (-1) * roundNumber(this.costosEdit[15].monto * (this.costosEdit[16].porcentaje_nominal / 100), 6)
      this.costosNoEdit[16].porcentaje_nominal = roundNumber(this.costosEdit[16].porcentaje_nominal, 6)
      this.costosNoEdit[16].monto = (-1) * roundNumber(this.costosEdit[15].monto * (this.costosNoEdit[16].porcentaje_nominal / 100), 6)
      // MONTO ACREDITADO
      this.costosEdit[17].monto = roundNumber(this.costosEdit[15].monto + this.costosEdit[16].monto, 6)
      this.costosEdit[17].porcentaje_nominal = roundNumber((this.costosEdit[17].monto / this.costosEdit[0].monto) * 100, 6)
      this.costosNoEdit[17].monto = roundNumber(this.costosNoEdit[15].monto + this.costosNoEdit[16].monto, 6)
      this.costosNoEdit[17].porcentaje_nominal = roundNumber((this.costosNoEdit[17].monto / this.costosNoEdit[0].monto) * 100, 6)
      // COSTO INFLACIONARIO DIARIO
      this.costosEdit[18].porcentaje_nominal = roundNumber(this.costosEdit[18].porcentaje_nominal, 6)
      this.costosEdit[18].monto = (-1) * roundNumber(this.costosEdit[17].monto * (this.costosEdit[18].porcentaje_nominal / 100), 6)
      this.costosNoEdit[18].porcentaje_nominal = roundNumber(this.costosEdit[18].porcentaje_nominal, 6)
      this.costosNoEdit[18].monto = (-1) * roundNumber(this.costosEdit[17].monto * (this.costosNoEdit[18].porcentaje_nominal / 100), 6)
      // MONTO FINAL POR INFLACION
      this.costosEdit[19].monto = roundNumber(this.costosEdit[17].monto + this.costosEdit[18].monto, 6)
      this.costosEdit[19].porcentaje_nominal = roundNumber((this.costosEdit[19].monto / this.costosEdit[0].monto) * 100, 6)
      this.costosNoEdit[19].monto = roundNumber(this.costosNoEdit[17].monto + this.costosNoEdit[18].monto, 6)
      this.costosNoEdit[19].porcentaje_nominal = roundNumber((this.costosNoEdit[19].monto / this.costosNoEdit[0].monto) * 100, 6)
      // CALCULO EL MONTO DE LOS RESUMENES
      this.cfSinInf[0].monto = roundNumber(this.costosNoEdit[3].monto + this.costosNoEdit[4].monto + this.costosNoEdit[5].monto + this.costosNoEdit[9].monto +
                              this.costosNoEdit[10].monto + this.costosNoEdit[11].monto + this.costosNoEdit[14].monto + this.costosNoEdit[16].monto, 6)
      this.cfSinInf[0].porcentaje = roundNumber((this.cfSinInf[0].monto / (this.costosEdit[0].monto / 1.21)) * 100, 6)
      this.cfSinInf[1].monto = roundNumber(recargo_s_iva + this.cfSinInf[0].monto, 6)
      this.cfSinInf[1].porcentaje = roundNumber(this.costosEdit[1].porcentaje_nominal + this.cfSinInf[0].porcentaje, 6)
      
      this.cfConInf[0].monto = roundNumber(this.cfSinInf[0].monto + this.costosNoEdit[18].monto, 6)
      this.cfConInf[0].porcentaje = roundNumber((this.cfConInf[0].monto / (this.costosEdit[0].monto / 1.21)) * 100, 6)
      this.cfConInf[1].monto = roundNumber(this.cfConInf[0].monto + recargo_s_iva, 6)
      this.cfConInf[1].porcentaje = roundNumber(this.costosEdit[1].porcentaje_nominal + this.cfConInf[0].porcentaje, 6)

      if (!cadenaVacia(opcion) && !cadenaVacia(this.objetivo)){
        // llegué al objetivo?
        let porcCalculado = 0
        if (this.resSinInf == 1) porcCalculado = this.cfSinInf[1].porcentaje
        else porcCalculado = this.cfConInf[1].porcentaje
        if (porcCalculado == roundNumber(this.objetivo, 6)) return
        // intento nuevamente llegar al objetivo
        let porcentaje = 0
        if (this.resSinInf == 1) porcentaje = Math.abs(this.cfSinInf[0].porcentaje) + this.objetivo
        else porcentaje = Math.abs(this.cfConInf[0].porcentaje) + roundNumber(this.objetivo, 6)
        // actualizo el porcentaje
        this.costosEdit[1].porcentaje_nominal = porcentaje
        this.simular(1)
      }
    }
  },
  watch: {
    costosFin: function(){
      if (this.costosFin.length > 0){
        for (let id in this.costosFin){
          let monto_operacion = 100000
          // calculo del COSTO FINANCIERO SIN INFLACION
          let recargo_operacion = roundNumber(this.costosFin[id].porcentaje * monto_operacion, 6)
          let recargo_s_iva = roundNumber(recargo_operacion / 1.21, 6)
          let monto_cobrar_cliente = roundNumber(monto_operacion + recargo_operacion, 6)
          let arancel = roundNumber(monto_cobrar_cliente * this.costosFin[id].arancel, 6)
          let costo_financiero = roundNumber(monto_cobrar_cliente * this.costosFin[id].costo_financiero, 6)
          let bonificaciones = roundNumber(monto_cobrar_cliente * this.costosFin[id].bonificaciones, 6)
          let iva_arancel = roundNumber(arancel * this.costosFin[id].iva_arancel, 6)
          let iva_cf = roundNumber(costo_financiero * this.costosFin[id].iva_cf, 6)
          let iva_bonif = roundNumber(bonificaciones * this.costosFin[id].iva_bonif, 6)
          let ib_sobre_recargo = roundNumber(recargo_operacion * this.costosFin[id].ibb, 6)
          let imp_act_varias = roundNumber(recargo_operacion * this.costosFin[id].imp_act_varias, 6)
          let imp_ganancias = roundNumber(recargo_operacion * this.costosFin[id].imp_ganancias, 6)
          let monto_costo = (-1) * roundNumber(arancel + costo_financiero + bonificaciones + iva_arancel + iva_cf + iva_bonif + ib_sobre_recargo + imp_act_varias + imp_ganancias, 6)
          let monto_liq_antes_cheque = roundNumber(monto_cobrar_cliente + monto_costo, 6)
          let costo_cheques = (-1) * roundNumber(monto_liq_antes_cheque * this.costosFin[id].cheques, 6)
          let monto_liq = roundNumber(monto_liq_antes_cheque + costo_cheques, 6)
          let imp_deb_cred = (-1) * roundNumber(monto_liq * this.costosFin[id].deb_cred, 6)
          let monto_acreditado = roundNumber(monto_liq + imp_deb_cred, 6)
          let costo_inf_diario = (-1) * roundNumber(monto_acreditado * this.costosFin[id].inflacion, 6)
          // calculo los parametros de la otra tarjeta
          let ib_sobre_recargo_2 = roundNumber((recargo_operacion / 1.21) * this.costosFin[id].ibb, 6)
          let imp_act_varias_2 = roundNumber((recargo_operacion / 1.21) * this.costosFin[id].imp_act_varias, 6)
          let imp_ganancias_2 = roundNumber((recargo_operacion / 1.21) * this.costosFin[id].imp_ganancias, 6)

          let imp_cf_s_inflacion_neta = (-1) * roundNumber(arancel + costo_financiero + bonificaciones + ib_sobre_recargo_2 + imp_act_varias_2 + imp_ganancias_2 + ((-1) * costo_cheques) + ((-1) * imp_deb_cred), 6)
          let porc_cf_s_inflacion_neta = roundNumber((imp_cf_s_inflacion_neta / (monto_operacion / 1.21)) * 100, 6)
          let imp_res_eco_s_inf_s_iva = roundNumber(recargo_s_iva + imp_cf_s_inflacion_neta, 6)
          let porc_res_eco_s_inf_s_iva = roundNumber((this.costosFin[id].porcentaje * 100) + porc_cf_s_inflacion_neta, 6)

          let imp_cf_c_inflacion_neta = imp_cf_s_inflacion_neta + costo_inf_diario
          let porc_cf_c_inflacion_neta = roundNumber((imp_cf_c_inflacion_neta / (monto_operacion / 1.21)) * 100, 6)
          let porc_res_eco_c_inf_s_iva = roundNumber((this.costosFin[id].porcentaje * 100) + porc_cf_c_inflacion_neta, 6)

          // asigno los valores
          this.costosFin[id].costo_f_sin_inf = porc_cf_s_inflacion_neta
          this.costosFin[id].rdo_f_sin_inf = porc_res_eco_s_inf_s_iva
          this.costosFin[id].costo_f_con_inf = porc_cf_c_inflacion_neta
          this.costosFin[id].rdo_f_con_inf = porc_res_eco_c_inf_s_iva
        }
      }
    },
    dialogObj: function(){
      if (this.dialogObj == true) this.objetivo = 0
    }
  },
}
</script>

<style>
  .color-fila-ligth {
    background-color: #3498DB !important;
    font-weight: bold;
  }
  .color-fila-dark {
    background-color: #5DADE2 !important;
    font-weight: bold;
  }
  .color-green-dark {
    color: #A9D08E !important;
  }
  .color-green-ligth {
    color: #4CAF50 !important;
  }
</style>